"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: tier/tier.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftier%2Ftier.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscriptionRenewalToJSON = exports.subscriptionRenewalFromJSON = exports.TierSubscription = exports.TypeChanged = exports.TierData = exports.UserTier = exports.TierOffer = exports.Subscription = exports.DirectDeposit = exports.TierBenefitsSavingsInterestRate = exports.TierBenefitsSavingsInterest = exports.TierBenefitsRewards = exports.TierBenefits = exports.Tier = exports.SubscriptionRenewal = void 0;
const amount_1 = require("../common/amount");
const image_1 = require("../common/image");
const product_variant_1 = require("../common/product-variant");
const qualifying_event_1 = require("../common/qualifying-event");
const duration_1 = require("../google/protobuf/duration");
const cancellation_reason_1 = require("./cancellation-reason");
const tier_type_1 = require("./tier-type");
const protobufPackage = 'com.step.tier.proto';
var SubscriptionRenewal;
(function (SubscriptionRenewal) {
    SubscriptionRenewal["INVALID_RENEWAL"] = "INVALID_RENEWAL";
    SubscriptionRenewal["ANNUAL"] = "ANNUAL";
    SubscriptionRenewal["MONTHLY"] = "MONTHLY";
    SubscriptionRenewal["UNRECOGNIZED"] = "UNRECOGNIZED";
})(SubscriptionRenewal || (exports.SubscriptionRenewal = SubscriptionRenewal = {}));
function createBaseTier() {
    return {
        type: tier_type_1.TierType.INVALID_TIER,
        annualFee: undefined,
        tierBenefits: exports.TierBenefits.fromPartial({}),
        directDeposit: undefined,
        subscription: undefined,
    };
}
exports.Tier = {
    fromJSON(object) {
        const message = {
            type: isSet(object.type) ? (0, tier_type_1.tierTypeFromJSON)(object.type) : tier_type_1.TierType.INVALID_TIER,
            tierBenefits: isSet(object.tierBenefits)
                ? exports.TierBenefits.fromJSON(object.tierBenefits)
                : exports.TierBenefits.fromPartial({}),
        };
        if (isSet(object.annualFee)) {
            message.annualFee = amount_1.Amount.fromJSON(object.annualFee);
        }
        if (isSet(object.directDeposit)) {
            message.directDeposit = exports.DirectDeposit.fromJSON(object.directDeposit);
        }
        if (isSet(object.subscription)) {
            message.subscription = exports.Subscription.fromJSON(object.subscription);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== tier_type_1.TierType.INVALID_TIER) {
            obj.type = (0, tier_type_1.tierTypeToJSON)(message.type);
        }
        if (message.annualFee !== undefined) {
            obj.annualFee = amount_1.Amount.toJSON(message.annualFee);
        }
        if (message.tierBenefits !== undefined) {
            obj.tierBenefits = exports.TierBenefits.toJSON(message.tierBenefits);
        }
        if (message.directDeposit !== undefined) {
            obj.directDeposit = exports.DirectDeposit.toJSON(message.directDeposit);
        }
        if (message.subscription !== undefined) {
            obj.subscription = exports.Subscription.toJSON(message.subscription);
        }
        return obj;
    },
    create(base) {
        return exports.Tier.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTier();
        message.type = object.type ?? tier_type_1.TierType.INVALID_TIER;
        message.annualFee = (object.annualFee !== undefined && object.annualFee !== null)
            ? amount_1.Amount.fromPartial(object.annualFee)
            : undefined;
        message.tierBenefits = (object.tierBenefits !== undefined && object.tierBenefits !== null)
            ? exports.TierBenefits.fromPartial(object.tierBenefits)
            : exports.TierBenefits.fromPartial({});
        message.directDeposit = (object.directDeposit !== undefined && object.directDeposit !== null)
            ? exports.DirectDeposit.fromPartial(object.directDeposit)
            : undefined;
        message.subscription = (object.subscription !== undefined && object.subscription !== null)
            ? exports.Subscription.fromPartial(object.subscription)
            : undefined;
        return message;
    },
};
function createBaseTierBenefits() {
    return {
        rewards: exports.TierBenefitsRewards.fromPartial({}),
        savingsInterest: exports.TierBenefitsSavingsInterest.fromPartial({}),
        offers: [],
        annualValue: undefined,
    };
}
exports.TierBenefits = {
    fromJSON(object) {
        const message = {
            rewards: isSet(object.rewards)
                ? exports.TierBenefitsRewards.fromJSON(object.rewards)
                : exports.TierBenefitsRewards.fromPartial({}),
            savingsInterest: isSet(object.savingsInterest)
                ? exports.TierBenefitsSavingsInterest.fromJSON(object.savingsInterest)
                : exports.TierBenefitsSavingsInterest.fromPartial({}),
            offers: globalThis.Array.isArray(object?.offers)
                ? object.offers.map((e) => exports.TierOffer.fromJSON(e))
                : [],
        };
        if (isSet(object.annualValue)) {
            message.annualValue = amount_1.Amount.fromJSON(object.annualValue);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.rewards !== undefined) {
            obj.rewards = exports.TierBenefitsRewards.toJSON(message.rewards);
        }
        if (message.savingsInterest !== undefined) {
            obj.savingsInterest = exports.TierBenefitsSavingsInterest.toJSON(message.savingsInterest);
        }
        if (message.offers?.length) {
            obj.offers = message.offers.map((e) => exports.TierOffer.toJSON(e));
        }
        if (message.annualValue !== undefined) {
            obj.annualValue = amount_1.Amount.toJSON(message.annualValue);
        }
        return obj;
    },
    create(base) {
        return exports.TierBenefits.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTierBenefits();
        message.rewards = (object.rewards !== undefined && object.rewards !== null)
            ? exports.TierBenefitsRewards.fromPartial(object.rewards)
            : exports.TierBenefitsRewards.fromPartial({});
        message.savingsInterest =
            (object.savingsInterest !== undefined && object.savingsInterest !== null)
                ? exports.TierBenefitsSavingsInterest.fromPartial(object.savingsInterest)
                : exports.TierBenefitsSavingsInterest.fromPartial({});
        message.offers = object.offers?.map((e) => exports.TierOffer.fromPartial(e)) || [];
        message.annualValue = (object.annualValue !== undefined && object.annualValue !== null)
            ? amount_1.Amount.fromPartial(object.annualValue)
            : undefined;
        return message;
    },
};
function createBaseTierBenefitsRewards() {
    return { cashBackRate: 0 };
}
exports.TierBenefitsRewards = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.cashBackRate)) {
            message.cashBackRate = globalThis.Number(object.cashBackRate);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cashBackRate !== undefined && message.cashBackRate !== 0) {
            obj.cashBackRate = message.cashBackRate;
        }
        return obj;
    },
    create(base) {
        return exports.TierBenefitsRewards.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTierBenefitsRewards();
        message.cashBackRate = object.cashBackRate ?? 0;
        return message;
    },
};
function createBaseTierBenefitsSavingsInterest() {
    return { rates: [], savingsBalanceCap: amount_1.Amount.fromPartial({}) };
}
exports.TierBenefitsSavingsInterest = {
    fromJSON(object) {
        const message = {
            rates: globalThis.Array.isArray(object?.rates)
                ? object.rates.map((e) => exports.TierBenefitsSavingsInterestRate.fromJSON(e))
                : [],
            savingsBalanceCap: isSet(object.savingsBalanceCap)
                ? amount_1.Amount.fromJSON(object.savingsBalanceCap)
                : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.rates?.length) {
            obj.rates = message.rates.map((e) => exports.TierBenefitsSavingsInterestRate.toJSON(e));
        }
        if (message.savingsBalanceCap !== undefined) {
            obj.savingsBalanceCap = amount_1.Amount.toJSON(message.savingsBalanceCap);
        }
        return obj;
    },
    create(base) {
        return exports.TierBenefitsSavingsInterest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTierBenefitsSavingsInterest();
        message.rates = object.rates?.map((e) => exports.TierBenefitsSavingsInterestRate.fromPartial(e)) || [];
        message.savingsBalanceCap =
            (object.savingsBalanceCap !== undefined && object.savingsBalanceCap !== null)
                ? amount_1.Amount.fromPartial(object.savingsBalanceCap)
                : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseTierBenefitsSavingsInterestRate() {
    return { effectiveAtMs: '0', nominalRate: 0, apyRate: 0 };
}
exports.TierBenefitsSavingsInterestRate = {
    fromJSON(object) {
        const message = {
            effectiveAtMs: isSet(object.effectiveAtMs) ? globalThis.String(object.effectiveAtMs) : '0',
            nominalRate: isSet(object.nominalRate) ? globalThis.Number(object.nominalRate) : 0,
            apyRate: isSet(object.apyRate) ? globalThis.Number(object.apyRate) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.effectiveAtMs !== '0') {
            obj.effectiveAtMs = message.effectiveAtMs;
        }
        if (message.nominalRate !== 0) {
            obj.nominalRate = message.nominalRate;
        }
        if (message.apyRate !== 0) {
            obj.apyRate = message.apyRate;
        }
        return obj;
    },
    create(base) {
        return exports.TierBenefitsSavingsInterestRate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTierBenefitsSavingsInterestRate();
        message.effectiveAtMs = object.effectiveAtMs ?? '0';
        message.nominalRate = object.nominalRate ?? 0;
        message.apyRate = object.apyRate ?? 0;
        return message;
    },
};
function createBaseDirectDeposit() {
    return { minimumAmount: amount_1.Amount.fromPartial({}), periodDays: 0, currentAmount: undefined };
}
exports.DirectDeposit = {
    fromJSON(object) {
        const message = {
            minimumAmount: isSet(object.minimumAmount)
                ? amount_1.Amount.fromJSON(object.minimumAmount)
                : amount_1.Amount.fromPartial({}),
            periodDays: isSet(object.periodDays) ? globalThis.Number(object.periodDays) : 0,
        };
        if (isSet(object.currentAmount)) {
            message.currentAmount = amount_1.Amount.fromJSON(object.currentAmount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.minimumAmount !== undefined) {
            obj.minimumAmount = amount_1.Amount.toJSON(message.minimumAmount);
        }
        if (message.periodDays !== 0) {
            obj.periodDays = Math.round(message.periodDays);
        }
        if (message.currentAmount !== undefined) {
            obj.currentAmount = amount_1.Amount.toJSON(message.currentAmount);
        }
        return obj;
    },
    create(base) {
        return exports.DirectDeposit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDirectDeposit();
        message.minimumAmount = (object.minimumAmount !== undefined && object.minimumAmount !== null)
            ? amount_1.Amount.fromPartial(object.minimumAmount)
            : amount_1.Amount.fromPartial({});
        message.periodDays = object.periodDays ?? 0;
        message.currentAmount = (object.currentAmount !== undefined && object.currentAmount !== null)
            ? amount_1.Amount.fromPartial(object.currentAmount)
            : undefined;
        return message;
    },
};
function createBaseSubscription() {
    return {
        cost: amount_1.Amount.fromPartial({}),
        renewal: SubscriptionRenewal.INVALID_RENEWAL,
        hasFreeTrial: false,
        productVariant: undefined,
        trialCost: undefined,
        trialPeriod: undefined,
        trialPeriodDays: undefined,
    };
}
exports.Subscription = {
    fromJSON(object) {
        const message = {
            cost: isSet(object.cost) ? amount_1.Amount.fromJSON(object.cost) : amount_1.Amount.fromPartial({}),
            renewal: isSet(object.renewal)
                ? subscriptionRenewalFromJSON(object.renewal)
                : SubscriptionRenewal.INVALID_RENEWAL,
        };
        if (isSet(object.hasFreeTrial)) {
            message.hasFreeTrial = globalThis.Boolean(object.hasFreeTrial);
        }
        if (isSet(object.productVariant)) {
            message.productVariant = (0, product_variant_1.productVariantFromJSON)(object.productVariant);
        }
        if (isSet(object.trialCost)) {
            message.trialCost = amount_1.Amount.fromJSON(object.trialCost);
        }
        if (isSet(object.trialPeriod)) {
            message.trialPeriod = duration_1.Duration.fromJSON(object.trialPeriod);
        }
        if (isSet(object.trialPeriodDays)) {
            message.trialPeriodDays = globalThis.Number(object.trialPeriodDays);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cost !== undefined) {
            obj.cost = amount_1.Amount.toJSON(message.cost);
        }
        if (message.renewal !== SubscriptionRenewal.INVALID_RENEWAL) {
            obj.renewal = subscriptionRenewalToJSON(message.renewal);
        }
        if (message.hasFreeTrial !== undefined && message.hasFreeTrial !== false) {
            obj.hasFreeTrial = message.hasFreeTrial;
        }
        if (message.productVariant !== undefined) {
            obj.productVariant = (0, product_variant_1.productVariantToJSON)(message.productVariant);
        }
        if (message.trialCost !== undefined) {
            obj.trialCost = amount_1.Amount.toJSON(message.trialCost);
        }
        if (message.trialPeriod !== undefined) {
            obj.trialPeriod = duration_1.Duration.toJSON(message.trialPeriod);
        }
        if (message.trialPeriodDays !== undefined) {
            obj.trialPeriodDays = Math.round(message.trialPeriodDays);
        }
        return obj;
    },
    create(base) {
        return exports.Subscription.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscription();
        message.cost = (object.cost !== undefined && object.cost !== null)
            ? amount_1.Amount.fromPartial(object.cost)
            : amount_1.Amount.fromPartial({});
        message.renewal = object.renewal ?? SubscriptionRenewal.INVALID_RENEWAL;
        message.hasFreeTrial = object.hasFreeTrial ?? false;
        message.productVariant = object.productVariant ?? undefined;
        message.trialCost = (object.trialCost !== undefined && object.trialCost !== null)
            ? amount_1.Amount.fromPartial(object.trialCost)
            : undefined;
        message.trialPeriod = (object.trialPeriod !== undefined && object.trialPeriod !== null)
            ? duration_1.Duration.fromPartial(object.trialPeriod)
            : undefined;
        message.trialPeriodDays = object.trialPeriodDays ?? undefined;
        return message;
    },
};
function createBaseTierOffer() {
    return { icon: image_1.Image.fromPartial({}), description: '', pointsMultiplier: undefined };
}
exports.TierOffer = {
    fromJSON(object) {
        const message = {
            icon: isSet(object.icon) ? image_1.Image.fromJSON(object.icon) : image_1.Image.fromPartial({}),
            description: isSet(object.description) ? globalThis.String(object.description) : '',
        };
        if (isSet(object.pointsMultiplier)) {
            message.pointsMultiplier = globalThis.Number(object.pointsMultiplier);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.icon !== undefined) {
            obj.icon = image_1.Image.toJSON(message.icon);
        }
        if (message.description !== '') {
            obj.description = message.description;
        }
        if (message.pointsMultiplier !== undefined) {
            obj.pointsMultiplier = Math.round(message.pointsMultiplier);
        }
        return obj;
    },
    create(base) {
        return exports.TierOffer.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTierOffer();
        message.icon = (object.icon !== undefined && object.icon !== null)
            ? image_1.Image.fromPartial(object.icon)
            : image_1.Image.fromPartial({});
        message.description = object.description ?? '';
        message.pointsMultiplier = object.pointsMultiplier ?? undefined;
        return message;
    },
};
function createBaseUserTier() {
    return {
        userId: '',
        tierType: tier_type_1.TierType.INVALID_TIER,
        updatedAtMs: '0',
        expiresAtMs: '0',
        qualifyingEvent: qualifying_event_1.QualifyingEvent.INVALID_QUALIFYING_EVENT,
        productVariant: undefined,
    };
}
exports.UserTier = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            tierType: isSet(object.tierType) ? (0, tier_type_1.tierTypeFromJSON)(object.tierType) : tier_type_1.TierType.INVALID_TIER,
            updatedAtMs: isSet(object.updatedAtMs) ? globalThis.String(object.updatedAtMs) : '0',
        };
        if (isSet(object.expiresAtMs)) {
            message.expiresAtMs = globalThis.String(object.expiresAtMs);
        }
        if (isSet(object.qualifyingEvent)) {
            message.qualifyingEvent = (0, qualifying_event_1.qualifyingEventFromJSON)(object.qualifyingEvent);
        }
        if (isSet(object.productVariant)) {
            message.productVariant = (0, product_variant_1.productVariantFromJSON)(object.productVariant);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.tierType !== tier_type_1.TierType.INVALID_TIER) {
            obj.tierType = (0, tier_type_1.tierTypeToJSON)(message.tierType);
        }
        if (message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        if (message.expiresAtMs !== undefined && message.expiresAtMs !== '0') {
            obj.expiresAtMs = message.expiresAtMs;
        }
        if (message.qualifyingEvent !== undefined &&
            message.qualifyingEvent !== qualifying_event_1.QualifyingEvent.INVALID_QUALIFYING_EVENT) {
            obj.qualifyingEvent = (0, qualifying_event_1.qualifyingEventToJSON)(message.qualifyingEvent);
        }
        if (message.productVariant !== undefined) {
            obj.productVariant = (0, product_variant_1.productVariantToJSON)(message.productVariant);
        }
        return obj;
    },
    create(base) {
        return exports.UserTier.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserTier();
        message.userId = object.userId ?? '';
        message.tierType = object.tierType ?? tier_type_1.TierType.INVALID_TIER;
        message.updatedAtMs = object.updatedAtMs ?? '0';
        message.expiresAtMs = object.expiresAtMs ?? '0';
        message.qualifyingEvent = object.qualifyingEvent ?? qualifying_event_1.QualifyingEvent.INVALID_QUALIFYING_EVENT;
        message.productVariant = object.productVariant ?? undefined;
        return message;
    },
};
function createBaseTierData() {
    return { typeChanged: undefined };
}
exports.TierData = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.typeChanged)) {
            message.typeChanged = exports.TypeChanged.fromJSON(object.typeChanged);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.typeChanged !== undefined) {
            obj.typeChanged = exports.TypeChanged.toJSON(message.typeChanged);
        }
        return obj;
    },
    create(base) {
        return exports.TierData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTierData();
        message.typeChanged = (object.typeChanged !== undefined && object.typeChanged !== null)
            ? exports.TypeChanged.fromPartial(object.typeChanged)
            : undefined;
        return message;
    },
};
function createBaseTypeChanged() {
    return { atMs: '0', from: tier_type_1.TierType.INVALID_TIER };
}
exports.TypeChanged = {
    fromJSON(object) {
        const message = {
            atMs: isSet(object.atMs) ? globalThis.String(object.atMs) : '0',
            from: isSet(object.from) ? (0, tier_type_1.tierTypeFromJSON)(object.from) : tier_type_1.TierType.INVALID_TIER,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.atMs !== '0') {
            obj.atMs = message.atMs;
        }
        if (message.from !== tier_type_1.TierType.INVALID_TIER) {
            obj.from = (0, tier_type_1.tierTypeToJSON)(message.from);
        }
        return obj;
    },
    create(base) {
        return exports.TypeChanged.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTypeChanged();
        message.atMs = object.atMs ?? '0';
        message.from = object.from ?? tier_type_1.TierType.INVALID_TIER;
        return message;
    },
};
function createBaseTierSubscription() {
    return {
        userId: '',
        tierType: tier_type_1.TierType.INVALID_TIER,
        isAutoRenew: false,
        subscribedAtMs: '0',
        renewAtMs: '0',
        canceledAtMs: '0',
        referenceId: '',
        renewal: SubscriptionRenewal.INVALID_RENEWAL,
        cancellationReason: undefined,
        externalPaymentAccountId: undefined,
    };
}
exports.TierSubscription = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            tierType: isSet(object.tierType) ? (0, tier_type_1.tierTypeFromJSON)(object.tierType) : tier_type_1.TierType.INVALID_TIER,
            isAutoRenew: isSet(object.isAutoRenew) ? globalThis.Boolean(object.isAutoRenew) : false,
            subscribedAtMs: isSet(object.subscribedAtMs) ? globalThis.String(object.subscribedAtMs) : '0',
            renewAtMs: isSet(object.renewAtMs) ? globalThis.String(object.renewAtMs) : '0',
        };
        if (isSet(object.canceledAtMs)) {
            message.canceledAtMs = globalThis.String(object.canceledAtMs);
        }
        if (isSet(object.referenceId)) {
            message.referenceId = globalThis.String(object.referenceId);
        }
        if (isSet(object.renewal)) {
            message.renewal = subscriptionRenewalFromJSON(object.renewal);
        }
        if (isSet(object.cancellationReason)) {
            message.cancellationReason = (0, cancellation_reason_1.cancellationReasonFromJSON)(object.cancellationReason);
        }
        if (isSet(object.externalPaymentAccountId)) {
            message.externalPaymentAccountId = globalThis.String(object.externalPaymentAccountId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.tierType !== tier_type_1.TierType.INVALID_TIER) {
            obj.tierType = (0, tier_type_1.tierTypeToJSON)(message.tierType);
        }
        if (message.isAutoRenew !== false) {
            obj.isAutoRenew = message.isAutoRenew;
        }
        if (message.subscribedAtMs !== '0') {
            obj.subscribedAtMs = message.subscribedAtMs;
        }
        if (message.renewAtMs !== '0') {
            obj.renewAtMs = message.renewAtMs;
        }
        if (message.canceledAtMs !== undefined && message.canceledAtMs !== '0') {
            obj.canceledAtMs = message.canceledAtMs;
        }
        if (message.referenceId !== undefined && message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        if (message.renewal !== undefined && message.renewal !== SubscriptionRenewal.INVALID_RENEWAL) {
            obj.renewal = subscriptionRenewalToJSON(message.renewal);
        }
        if (message.cancellationReason !== undefined) {
            obj.cancellationReason = (0, cancellation_reason_1.cancellationReasonToJSON)(message.cancellationReason);
        }
        if (message.externalPaymentAccountId !== undefined) {
            obj.externalPaymentAccountId = message.externalPaymentAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.TierSubscription.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTierSubscription();
        message.userId = object.userId ?? '';
        message.tierType = object.tierType ?? tier_type_1.TierType.INVALID_TIER;
        message.isAutoRenew = object.isAutoRenew ?? false;
        message.subscribedAtMs = object.subscribedAtMs ?? '0';
        message.renewAtMs = object.renewAtMs ?? '0';
        message.canceledAtMs = object.canceledAtMs ?? '0';
        message.referenceId = object.referenceId ?? '';
        message.renewal = object.renewal ?? SubscriptionRenewal.INVALID_RENEWAL;
        message.cancellationReason = object.cancellationReason ?? undefined;
        message.externalPaymentAccountId = object.externalPaymentAccountId ?? undefined;
        return message;
    },
};
function subscriptionRenewalFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_RENEWAL':
            return SubscriptionRenewal.INVALID_RENEWAL;
        case 1:
        case 'ANNUAL':
            return SubscriptionRenewal.ANNUAL;
        case 2:
        case 'MONTHLY':
            return SubscriptionRenewal.MONTHLY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return SubscriptionRenewal.UNRECOGNIZED;
    }
}
exports.subscriptionRenewalFromJSON = subscriptionRenewalFromJSON;
function subscriptionRenewalToJSON(object) {
    switch (object) {
        case SubscriptionRenewal.INVALID_RENEWAL:
            return 'INVALID_RENEWAL';
        case SubscriptionRenewal.ANNUAL:
            return 'ANNUAL';
        case SubscriptionRenewal.MONTHLY:
            return 'MONTHLY';
        case SubscriptionRenewal.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.subscriptionRenewalToJSON = subscriptionRenewalToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tier.js.map